/*
 * @Author: caiqin.xie
 * @since: 2023-06-28 17:12:46
 * @lastTime: 2023-09-18 09:42:59
 * @LastEditors: caiqin.xie
 * @message: 
 */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./index.module.scss";

interface Obj {
  [key: string]: string;
}

const Header = (props: any) => {
  const { words } = props
  const headerLinks = () => (
    <> 
      <div className={styles.item}>
        <a className="navLink" href={`/${props.ctry}`}>
          {words?.header_home}
        </a>
      </div>
      <div className={styles.item}>
        <a className="navLink" href={`/${props.ctry}/blog`}>
          {words?.header_blog}
        </a>
      </div>
      <div className={styles.item}>
        <a className="navLink" href={`/${props.ctry}/software`}>
        {words?.header_software}
        </a>
      </div>
      <div className={styles.item}>
        <a className="navLink" href={`/${props.ctry}/support`}>
        {words?.header_support}
        </a>
      </div>
      <div className={styles.item}>
        <a className="navLink" href={`/${props.ctry}/shop`}>
        {words?.header_shop}
        </a>
      </div>
      <div className={styles.item}>
        <a className="navLink" href={`/${props.ctry}/newsroom`}>
        {words?.header_newsroom}
        </a>
      </div>
      <div className={styles.item}>
        <a className="navLink" href={`/${props.ctry}/accessory`}>
        {words?.header_fittings}
        </a>
      </div>
      <div className={styles.item}>
        <a className="navLink" href={`/${props.ctry}/about`}>
        {words?.header_about}
        </a>
      </div>
    </>
  );

  const [isShowMenu, setIsShowMenu] = useState(false);

  return (
    <header className={styles.header}>
      <div className={styles.menu}>
        <a className={styles.logo} href={`/${props.ctry}`} />
        <div className={styles.items}>
          {headerLinks()}
          <div className={`${styles.item} ${styles.itemAccount}`}></div>
          <div className={`${styles.item} ${styles.itemLanguage}`}></div>
        </div>
        <div className={styles.mItems}>
          <div className={styles.micon}>
            {!isShowMenu && (
              <div className={`${styles.item} ${styles.itemMenu}`} onClick={() => setIsShowMenu(true)}></div>
            )}
            {isShowMenu && (
              <div className={`${styles.item} ${styles.itemClose}`} onClick={() => setIsShowMenu(false)}></div>
            )}
          </div>
          <div className={`${styles.hiddenMenu} ${isShowMenu ? styles.show : styles.hide}`}>
            {headerLinks()}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
